import {Box, Typography} from '@mui/material'
import React from 'react'
import {DateTimeInput, number, SelectInput, TextInput} from 'react-admin'
import {useWatch} from 'react-hook-form'

export default function FieldsInfos() {
	const administrativeStatus = useWatch({name: 'administrative_status'})

	return (
		<Box sx={{
			display: 'flex',
			flexDirection: 'column'
		}}>
			<Typography variant="h6" gutterBottom>Informations complémentaires</Typography>
			<TextInput
				label="SIREN"
				name="siren"
				source="siren"
				fullWidth
			/>
			<TextInput
				label="Code APE"
				name="code_ape"
				source="code_ape"
				fullWidth
			/>
			<TextInput
				label="Code emballeur"
				name="code_packer"
				source="code_packer"
				fullWidth
			/>
			<TextInput
				label="Identifiant MGC (ITL)"
				name="client_id"
				source="client_id"
				fullWidth
				validate={[number()]}
			/>

			<Typography variant="h6" gutterBottom sx={{mt: 3}}>Données SIRENE</Typography>
			<SelectInput
				label="Statut administratif"
				name="administrative_status"
				source="administrative_status"
				choices={[
					{id: 'A', name: 'Actif'},
					{id: 'C', name: 'Cessé'}
				]}
				fullWidth
				helperText="Statut selon la base SIRENE de l'INSEE"
			/>
			<TextInput
				label="Effectifs"
				source="effectifs"
				fullWidth
				disabled
				helperText="Nombre d'employés de l'établissement (mis à jour automatiquement)"
			/>
			{administrativeStatus === 'C' && (
				<DateTimeInput
					label="Date de cessation d'activité"
					name="cessation_date"
					source="cessation_date"
					fullWidth
					disabled
					helperText="Date de cessation selon la base SIRENE"
				/>
			)}
			<DateTimeInput
				label="Dernière synchronisation SIRENE"
				name="sirene_last_update"
				source="sirene_last_update"
				fullWidth
				disabled
				helperText="Date de dernière mise à jour des données SIRENE"
			/>

			<Typography variant="h6" gutterBottom sx={{mt: 3}}>Données financières</Typography>
			<TextInput
				label="Dernier chiffre d'affaires connu"
				name="ca"
				source="ca"
				fullWidth
				disabled
				helperText="Chiffre d'affaires en euros"
				format={(value) => value ? `${parseFloat(value).toLocaleString('fr-FR')} €` : ''}
			/>
			<TextInput
				label="Capital social"
				name="capital_social"
				source="capital_social"
				fullWidth
				disabled
				helperText="Capital social en euros"
				format={(value) => value ? `${parseFloat(value).toLocaleString('fr-FR')} €` : ''}
			/>
		</Box>
	)
}
